import { FormControl, Validators } from '@angular/forms';


const SPECIAL_CHARS_PATTERN: RegExp = /^[^<>%#&?,]+$/;
const SPECIAL_CHARS_TEXT = '<>%#&?,';
const SPECIAL_CHARS_LITE_PATTERN: RegExp = /^[^<>%#?]+$/;
const SPECIAL_CHARS_LITE_TEXT = '<>%#?';
const username_maxLength = 128;
const notes_maxLength = 1000;

export const username_notExisting = 'userNotExisting';
export const username_notEligible_jps = 'userNotEligibleJps';
export const username_notEligible_fitbone = 'userNotEligibleFitbone';
export const username_notEligible_tlhex = 'userNotEligibleTlhex';
export const username_caseVersionMismatch = 'caseVersionMismatch';


export class PlanSendControl implements PlanSendControl {
	userGuid = new FormControl<string | null>(null, [Validators.required]);
	planGuid = new FormControl<string | null>(null, [Validators.required]);
	userName = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(username_maxLength), Validators.pattern(SPECIAL_CHARS_PATTERN), Validators.email]);
	notes = new FormControl<string | null>(null, [Validators.maxLength(notes_maxLength), Validators.pattern(SPECIAL_CHARS_LITE_PATTERN)]);
}

export const planSendErrorMsgs: { [key in keyof PlanSendForm]: { [y: string]: string[] } | null } = {
	userGuid: null,
	planGuid: null,
	userName: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_USERNAME'],
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_USERNAME', username_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_USERNAME', SPECIAL_CHARS_TEXT],
		[`${Validators.email.name}`]: ['VALIDATION_MESSAGE_FORMAT_USERNAME'],
		[`${username_notExisting}`]: ['VALIDATION_MESSAGE_NOT_EXIST_USERNAME'],
		[`${username_notEligible_jps}`]: ['VALIDATION_MESSAGE_NOT_ELIGIBLE_USERNAME', 'JPS'],
		[`${username_notEligible_fitbone}`]: ['VALIDATION_MESSAGE_NOT_ELIGIBLE_USERNAME', 'FITBONE'],
		[`${username_notEligible_tlhex}`]: ['VALIDATION_MESSAGE_NOT_ELIGIBLE_USERNAME', 'TL-HEX']
	},
	notes: {
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PLAN_NOTES', notes_maxLength.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PLAN_NOTES', SPECIAL_CHARS_LITE_TEXT],
	}
}

export interface IPlanSendControl {
	userGuid: FormControl<string | null>;
	planGuid: FormControl<string | null>;
	userName: FormControl<string | null>;
	notes: FormControl<string | null>;
}

export interface PlanSendForm {
	userGuid: string;
	planGuid: string;
	userName: string;
	notes: string;
}

